<template>
  <div>
    <v-menu top :close-on-content-click="false">
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="ml-3" v-bind="attrs" v-on="on" icon>
          <v-icon>mdi-filter-plus</v-icon>
        </v-btn>
      </template>

      <v-card id="card-filtro-colunas">
        <div class="pa-2 pb-1" style="display: flex">
          <v-icon class="mr-2">mdi-eye</v-icon>
          <h3 style="font-weight: 500">Exibir colunas</h3>
        </div>
        <v-divider class="pb-5" />
        <template v-for="(item, index) in headersFull">
          <template v-if="headersGerenciados.includes(item.value)">
            <div :key="index" class="item-coluna">
              <v-btn icon @click.stop="addOuRemoverColunaTabela(item);salvarHeadersCarrinho();">
                <v-icon v-if="headersPersonalizado.includes(item)" color="primary">
                  mdi-checkbox-marked
                </v-icon>
                <v-icon v-else>mdi-checkbox-blank-outline</v-icon>
              </v-btn>
              <p class="pt-1">{{ item.text }}</p>
            </div>
          </template>
        </template>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import CarrinhoAPI from "../../../api/carrinho";
import Api from "@/api/api.js";

export default {
  name: "OcultarColunas.vue",
  model: {
    prop: 'headers',
    event: 'change'
  },
  props: {
    headers: {
      default: []
    }
  },
  data () {
    return {
      headersGerenciados: [
        'codigo_barras',
        'estoque',
        'peso',
        'cubagem',
        'cobertura_estoque_futura',
        'preco_liquido_total',
        'classificacao_rentabilidade',
        'classificacao_criticidade',
        'lastro_palete',
        'altura_palete',
        'qt_total_palete',
        'compra_em_palete',
        'data_ultima_entrada'
      ],
      headersPersonalizado: [],
      headersFull: [
        { text: "#", value: "item", width: "2%" },
        { text: 'Fornecedor', value: 'razao_social' },
        { text: "ID Produto", value: "idproduto" },
        { text: "Cód. Barras", value: "codigo_barras" },
        { text: "Cód. Fabricante", value: "cod_produto" },
        { text: 'Número Original', value: 'numero_original' },
        { text: "Descrição Produto", value: "descricao_produto" },
        { text: "Peso (Kg)", class: 'text-start', value: "peso", width: "4%", align: 'center' },
        { text: "Cubagem (M³)", class: 'text-start', value: "cubagem", width: "5%", align: 'center' },
        { text: "Última Compra", value: "data_ultima_requisicao" },
        { text: "Última Entrada", value: "data_ultima_entrada" },
        { text: "Estoque", value: "estoque" },
        { text: "UND", value: "unidade_compra", width: "2%" },
        { text: "Linha do Produto", value: "descricao_linha", align: "center" },
        { text: "Sugestão em galão", value: "sugestao_em_litragem", sortable: false, align: "center" },
        { text: 'Lastro Palete', value: 'lastro_palete' },
        { text: 'Altura Palete', value: 'altura_palete' },
        { text: 'Qt. Total Palete', value: 'qt_total_palete' },
        { text: 'Compra em pallet', value: 'compra_em_palete' },
        { text: "Sugerido", class: 'text-start', value: "sugerido", width: "4%", align: 'center' },
        { text: "", value: "icon_motivos", sortable: false, width: "1%" },
        { text: "Quantidade", value: "qtde_pedido", sortable: false, align: "center", width: "7%" },
        { text: "Cobertura Estoque Futura (dias)", class: 'text-start', value: "cobertura_estoque_futura", sortable: false, align: "center", width: "8%" },
        { text: "Último Preço", value: "preco_custo_base", class: 'text-start', width: "6%", align: "center" },
        { text: "Preço Atual", value: "preco_custo", align: "center", width: "7%" },
        { text: "Indicador (%)", class: 'text-start', value: "indicador", align: "center", width: "5%" },
        { text: "Preço Total", class: 'text-start', value: "total", width: "7%", align: "center" },
        { text: "Preço Líquido Total", class: 'text-start', value: "preco_liquido_total", width: "7%", align: "center" },
        { text: "ABC Faturamento", value: "classificacao_rentabilidade", sortable: false, width: "7%", align: "center" },
        { text: "ABC Rentabilidade", value: "classificacao_criticidade", sortable: false, width: "7%", align: "center" },
        { text: "", value: "action", sortable: false, width: "2%", align: "center" },
      ]
    }
  },
  computed: {
    ...mapGetters({
      configuracoes: "configuracoes/carrinho" ,
      getFornecedor: "fornecedor/getFornecedor",
      CONFIG_FORNECEDOR: "fornecedor/getConfig",
    })
  },
  mounted () {
    let headers = [];

    if (localStorage.analiseGrupoFornecedores === 'S') {
      headers = this.headersFull;
    } else {
      headers = this.headersFull.filter((item) => item.value !== 'razao_social');
    }

    if (localStorage.ativar_exibicao_campo_numero_original !== 'S') {
      headers = headers.filter(item => item.value !== 'numero_original');
    }

    this.headersFull = headers;
    this.addOuRemoverColunaTabela();
    // this.verificaHeadersSalvoDoUsuario();
    this.buscarConfiguracaoHeaders();
  },
  methods: {
    addOuRemoverColunaTabela (item = {}, alterarNoVuex = true) {
      if (!item.text) {
        const FILTAR_COLUNAS_OCULTAR = valor => !this.headersGerenciados.includes(valor.value)

        this.headersPersonalizado = this.headersFull.filter(FILTAR_COLUNAS_OCULTAR)
      } else {
        const INCLUIDO = this.headersPersonalizado.includes(item)

        if (INCLUIDO) {
          const FILTRA_ITEM = valor => valor !== item

          this.headersPersonalizado = this.headersPersonalizado.filter(FILTRA_ITEM)
        } else {
          const NOVO_HEADER = this.headersPersonalizado.concat(item)

          const FILTAR_ITEM = valor => NOVO_HEADER.includes(valor)

          this.headersPersonalizado = this.headersFull.filter(FILTAR_ITEM)
        }

        if (alterarNoVuex) {
          this.alteraHeadersDoUsuarioNoVuex(item)
        }
      }

      if (!this.CONFIG_FORNECEDOR.calcular_litragem) {
        this.headersPersonalizado = this.headersPersonalizado.filter(item => !['descricao_linha', 'sugestao_em_litragem'].includes(item.value));
      }

      this.$emit('change', this.headersPersonalizado)
    },
    verificaHeadersSalvoDoUsuario () {
      const { headers } = this.configuracoes

      Object.keys(headers).forEach(key => {
        if (headers[key]) {
          const FILTRA_ITEM = item => item.value === key

          const item = this.headersFull.filter(FILTRA_ITEM)

          if (item[0]) this.addOuRemoverColunaTabela(item[0], false)
        }
      })
    },
    alteraHeadersDoUsuarioNoVuex (item) {
      const { value: KEY_HEADER } = item

      this.$store.dispatch("configuracoes/setHeader", KEY_HEADER)
    },
    buscarConfiguracaoHeaders() {
      Api.get('compras/configuracao')
        .then(response => {
          const { configs } = response.data;

          Object.keys(configs.headers).forEach(key => {
            if (!configs.headers[key]) return;

            const item = this.headersFull.find(item => item.value === key);

            if (item) {
              this.addOuRemoverColunaTabela(item);
            }
          });
        });
    },
    salvarHeadersCarrinho () {
      const headers = this.Helpers.iniciarRequisicao();

      const params = this.configuracoes.headers;

      this.$store.dispatch(
        "loading/addRequisicao",
        CarrinhoAPI.salvarColunasCarrinhoUsuario(headers, params)
          .then((response) => {
            const {token} = response.data
            localStorage.setItem("token", token)
          })
      )
    }
  }
}
</script>

<style scoped>
#card-filtro-colunas {
  overflow: hidden;
  width: 320px;
  padding: 5px;
}
#card-filtro-colunas .item-coluna {
  display: flex;
  padding: 0;
}
</style>
